<template>
    <modal
        name="extra-type-selector"
        :width="'720px'"
        :height="'auto'"
        :adaptive="true"
        :scrollable="true"
        :click-to-close="false"
    >
        <div class="extra-type-form">

            <!-- ==========================================
                 ENCABEZADO
            =========================================== -->
            <div class="form-header">

                <div class="form-header__content">

                    <div class="form-header__icon">
                        <i class="fa-solid fa-file-circle-plus"></i>
                    </div>

                    <div>
                        <h5 class="form-header__title">
                            Nuevo cargo extra
                        </h5>

                        <p class="form-header__subtitle">
                            Selecciona el tipo de cargo que deseas registrar.
                        </p>
                    </div>

                </div>


                <button
                    type="button"
                    class="form-close"
                    title="Cerrar"
                    aria-label="Cerrar"
                    @click="close"
                >
                    <i class="fa-solid fa-xmark"></i>
                </button>

            </div>


            <!-- ==========================================
                 CONTENIDO
            =========================================== -->
            <div class="form-body">

                <section class="form-section">

                    <div class="section-header">                       

                        <div>
                            <h6 class="section-title">
                                Tipo de cargo extra
                            </h6>

                            <p class="section-description">
                                Indica si el cargo está relacionado con un contrato existente.
                            </p>
                        </div>

                    </div>


                    <!-- ==================================
                         OPCIONES
                    =================================== -->
                    <div class="source-options">

                        <!-- CON CONTRATO -->
                        <button
                            type="button"
                            class="source-option source-option--button"
                            @click="selectWithContract"
                        >
                            <span class="source-option__icon">
                                <i class="fa-solid fa-file-contract"></i>
                            </span>

                            <span class="source-option__content">

                                <strong>
                                    Extra con contrato
                                </strong>

                                <small>
                                    El cargo pertenece a un contrato ya registrado
                                    y quedará relacionado con ese arrendamiento.
                                </small>

                                <span class="option-meta">
                                    <i class="fa-solid fa-link"></i>
                                    Vinculado a contrato
                                </span>

                            </span>

                            <span class="source-option__arrow">
                                <i class="fa-solid fa-chevron-right"></i>
                            </span>
                        </button>


                        <!-- SIN CONTRATO -->
                        <button
                            type="button"
                            class="source-option source-option--button"
                            @click="selectWithoutContract"
                        >
                            <span class="source-option__icon">
                                <i class="fa-solid fa-file-lines"></i>
                            </span>

                            <span class="source-option__content">

                                <strong>
                                    Extra sin contrato
                                </strong>

                                <small>
                                    El cargo es independiente y no necesita estar
                                    relacionado con ningún contrato.
                                </small>

                                <span class="option-meta">
                                    <i class="fa-solid fa-user"></i>
                                    Directo al cliente
                                </span>

                            </span>

                            <span class="source-option__arrow">
                                <i class="fa-solid fa-chevron-right"></i>
                            </span>
                        </button>

                    </div>                    

                </section>

            </div>


            <!-- ==========================================
                 PIE
            =========================================== -->
            <div class="form-footer">

                <button
                    type="button"
                    class="btn btn-light footer-button"
                    @click="close"
                >
                    Cancelar
                </button>

            </div>

        </div>
    </modal>
</template>


<script>
export default {

    name: 'ModalExtraTypeSelector',


    created() {

        Event.$on(
            'event-open-extra-type-selector',
            this.open
        );

    },


    beforeDestroy() {

        Event.$off(
            'event-open-extra-type-selector',
            this.open
        );

    },


    methods: {

        open() {

            this.$modal.show(
                'extra-type-selector'
            );

        },


        close() {

            this.$modal.hide(
                'extra-type-selector'
            );

        },


        selectWithContract() {

            this.close();

               Event.$emit(
                    'event-list-extra-services-all'
                );

            this.$nextTick(() => {

                Event.$emit(
                    'event-list-extra-services-all'
                );

            });

        },


        selectWithoutContract() {

            this.close();

            this.$nextTick(() => {

                Event.$emit(
                    'event-create-extra-due-without-contract'
                );

            });

        },

    },

};
</script>


<style scoped>
.extra-type-form {
    --primary: #5672a5;
    --primary-dark: #304d7d;
    --primary-soft: #eef3fb;

    --success: #269b74;
    --success-soft: #eaf8f3;

    --warning: #d99b24;
    --warning-soft: #fff8e8;

    --danger: #d84d5d;
    --danger-soft: #fff0f2;

    --border: #dfe5ee;
    --surface: #ffffff;
    --background: #f5f7fb;

    --text: #1f2937;
    --muted: #6b7280;

    min-height: 320px;

    color: var(--text);

    background: var(--background);
}


/* =========================================
   ENCABEZADO
========================================= */

.form-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    padding: 18px 22px;

    color: #ffffff;

    background:
        linear-gradient(
            135deg,
            var(--primary-dark),
            var(--primary)
        );
}


.form-header__content {
    display: flex;

    align-items: center;

    gap: 14px;
}


.form-header__icon {
    display: flex;

    align-items: center;
    justify-content: center;

    width: 46px;
    height: 46px;

    color: #ffffff;

    background:
        rgba(
            255,
            255,
            255,
            .15
        );

    border:
        1px solid
        rgba(
            255,
            255,
            255,
            .2
        );

    border-radius: 12px;

    font-size: 22px;
}


.form-header__title {
    margin: 0;

    font-size: 18px;
    font-weight: 700;
}


.form-header__subtitle {
    margin: 3px 0 0;

    color:
        rgba(
            255,
            255,
            255,
            .78
        );

    font-size: 12px;
}


.form-close {
    display: flex;

    align-items: center;
    justify-content: center;

    width: 36px;
    height: 36px;

    color: #ffffff;

    background:
        rgba(
            255,
            255,
            255,
            .12
        );

    border: 0;
    border-radius: 50%;

    cursor: pointer;

    transition: .2s ease;
}


.form-close:hover {
    background:
        rgba(
            255,
            255,
            255,
            .24
        );

    transform:
        rotate(
            90deg
        );
}


/* =========================================
   CONTENIDO
========================================= */

.form-body {
    max-height:
        calc(
            100vh - 185px
        );

    overflow-y: auto;
}


/* =========================================
   SECCIÓN
========================================= */

.form-section {
    padding: 20px;

    margin-bottom: 0;

    background: var(--surface);

    border:
        1px solid
        var(--border);

    box-shadow:
        0 3px 10px
        rgba(
            15,
            23,
            42,
            .04
        );
}


.section-header {
    display: flex;

    align-items: flex-start;

    gap: 12px;

    margin-bottom: 18px;
}


.section-number {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 30px;
    height: 30px;

    color: var(--primary-dark);

    background: var(--primary-soft);

    border-radius: 50%;

    font-size: 13px;
    font-weight: 700;
}


.section-title {
    margin: 1px 0 3px;

    color: var(--text);

    font-size: 15px;
    font-weight: 700;
}


.section-description {
    margin: 0;

    color: var(--muted);

    font-size: 12px;
}


/* =========================================
   OPCIONES
========================================= */

.source-options {
    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(
                0,
                1fr
            )
        );

    gap: 12px;
}


.source-option {
    position: relative;

    display: flex;

    align-items: center;

    gap: 12px;

    min-height: 108px;

    padding: 14px;

    margin: 0;

    color: inherit;

    text-align: left;

    background: #ffffff;

    border:
        1px solid
        var(--border);

    border-radius: 10px;

    cursor: pointer;

    transition: .2s ease;
}


.source-option--button {
    width: 100%;

    font-family: inherit;
}


.source-option:hover,
.source-option:focus {
    outline: none;

    border-color: var(--primary);

    box-shadow:
        0 4px 12px
        rgba(
            48,
            77,
            125,
            .08
        );

    transform:
        translateY(
            -1px
        );
}


.source-option__icon {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 42px;
    height: 42px;

    color: var(--primary);

    background: #f3f5f8;

    border-radius: 10px;

    font-size: 18px;
}


.source-option:hover .source-option__icon {
    background: var(--primary-soft);
}


.source-option__content {
    display: flex;

    flex: 1;
    flex-direction: column;

    min-width: 0;
}


.source-option__content strong {
    color: var(--text);

    font-size: 13px;
}


.source-option__content small {
    margin-top: 3px;

    color: var(--muted);

    font-size: 11px;
    line-height: 1.35;
}


.option-meta {
    display: inline-flex;

    align-items: center;

    gap: 5px;

    margin-top: 9px;

    color: var(--primary-dark);

    font-size: 10px;
    font-weight: 600;
}


.source-option__arrow {
    flex: 0 0 auto;

    color: #9ca3af;

    font-size: 11px;
}


.source-option:hover
.source-option__arrow {
    color: var(--primary);
}


/* =========================================
   AYUDA
========================================= */

.summary-help {
    display: flex;

    align-items: flex-start;

    gap: 8px;

    padding: 11px;

    margin-top: 14px;

    color: #42658f;

    background: #eef5ff;

    border: 1px solid #d6e6fb;
    border-radius: 10px;

    font-size: 10px;
}


.summary-help p {
    margin: 0;

    line-height: 1.45;
}


.summary-help i {
    margin-top: 2px;
}


/* =========================================
   FOOTER
========================================= */

.form-footer {
    display: flex;

    align-items: center;
    justify-content: flex-end;

    gap: 10px;

    padding: 14px 22px;

    background: #ffffff;

    border-top:
        1px solid
        var(--border);
}


.footer-button {
    min-width: 120px;

    padding: 9px 15px;

    border-radius: 7px;

    font-size: 12px;
}


/* =========================================
   RESPONSIVE
========================================= */

@media (
    max-width: 768px
) {

    .source-options {
        grid-template-columns:
            1fr;
    }


    .form-footer {
        flex-direction:
            column-reverse;
    }


    .footer-button {
        width: 100%;
    }

}
</style>
